import React from "react";

// STYLES
import * as Style from "./ReportStatisticElementStyle";

// LIBRARIES

// MISC
import { IProps } from "./ReportStatisticElementModel";

// ASSETS

// REDUX

// COMPONENTS

const ReportStatistic = (props:IProps) => {
  
  // PROPS
  const {onClick = () => {}, image = "", title = "", value =""} = props;

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return <Style.ReportStatisticElementContent onClick={onClick}>
            <Style.ImageContainer>
              <img src={image} alt="" />
            </Style.ImageContainer>
            <Style.TextContainer>
              <Style.TextContainerSubtitle>
                {title}
              </Style.TextContainerSubtitle>
              <Style.TextContainerInfo>
                {value}
              </Style.TextContainerInfo>
            </Style.TextContainer>
          </Style.ReportStatisticElementContent>
};

export default ReportStatistic;
